import Service from "../Service";

const statsbox = {

    getAllStatBox(page, industryId = 1) {
        switch (page) {
            case 'overview':
                return Service.get(`/api/frontend/overview/number`);
            case 'data-stats':
                return Service.get(`/api/statistic/number-industry?industry_id=${industryId}`);
        }
    }

};

export default statsbox;
